import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

const DEBOUNCE_TIMEOUT = 500
const SEARCH_CACHE_ROUTES = ['directory']
const shouldCacheSearchForRoute = (routeName) => {
	return SEARCH_CACHE_ROUTES.includes(routeName)
}

export default {
	methods: {
		...mapActions('app', ['cachePageFilters']),
		...mapActions('list', ['getListsMeta']),
		...mapActions('post', ['fetchPosts', 'getPollUsers']),
		...mapActions('event', [
			'fetchEvents',
			'getAttendeesEvent',
			'getAgendaEvent',
			'getBoothStaff',
			'getEventSpeakersById',
			'getActionFiles',
			'getActionLinks',
			'getSubSessions',
			'getAllSessionsSpeaker',
			'getSessionQuestions',
			'getPartnerFiles',
			'getGiveaways',
		]),
		...mapActions('profile', ['getProfileBookmarkList']),
		...mapActions('forum', ['fetchForums']),
		...mapActions('forum', ['fetchForumCategories']),
		...mapActions('directory', ['getDirectories', 'getSubDirectories']),
		...mapActions('resources', ['getResources', 'getResourcesById']),
		...mapActions('app', ['setSearch', 'getSort']),

		toggleFilterModalIsVisible() {
			this.filterModalIsVisible = !this.filterModalIsVisible
		},
		handleChipClick(payload) {
			const { name, label } = payload
			this.currentModalFilter = name
			this.currentModalLabel = label
			const autoApplyFilters = [
				'scheduled',
				'admin',
				'users',
				'register',
				'schedule',
				'follow',
				'event_follow',
				'categories',
				'registered',
				'myposts',
				'past',
				'bookmark',
				'my_questions',
				'recent',
			]

			const initDate = {
				selectedRange: {
					from: null,
					to: null,
				},
				option: null,
				error: '',
			}
			if (autoApplyFilters.includes(name) && this.isButtonActive(name)) {
				return
			}

			switch (name) {
				case 'clear': {
					const initFilters = {
						page: 1,
						myposts: false,
						past: false,
						field: null,
					}
					const needRequest =
						Object.values(this.selectedChips).some((value) => value.length) ||
						!_.isEqual(this.filters1, initFilters) ||
						!_.isEqual(this.date, initDate)
					this.selectedChips = {}
					this.filters = initFilters
					this.date = initDate
					needRequest && this.getFilteredItems()
					this.scrollPageTop()
					break
				}
				case 'recent':
				case 'my_questions':
				case 'bookmark':
				case 'scheduled':
				case 'admin':
				case 'users':
				case 'register':
				case 'schedule':
				case 'follow':
				case 'event_follow':
				case 'categories':
				case 'registered': {
					const currentFilters = this.selectedChips.filters
					const filter = this.filterValues.find((filter) => filter.name === name).filter
					if (currentFilters) {
						const filterIsOn = currentFilters.some((value) => value === filter)
						if (filterIsOn) {
							this.selectedChips.filters = currentFilters.filter(
								(item) => item !== filter
							)
						} else {
							this.selectedChips.filters = [
								...currentFilters.filter(
									(filter) =>
										!this.excludeConflictFilters(name).some(
											(item) => item === filter
										)
								),
								filter,
							]
						}
					} else {
						this.$set(this.selectedChips, 'filters', [filter])
					}
					this.applySelection()
					break
				}
				case 'myposts': {
					this.filters.myposts = !this.filters.myposts
					this.applySelection()
					break
				}
				case 'past': {
					const newValue = !this.filters.past
					this.filters.past = newValue
					this.date.option = null

					if (newValue) {
						const now = new Date()
						const year = now.getFullYear()
						const month = this.pad(now.getMonth() + 1)
						const day = this.pad(now.getDate())
						const hours = this.pad(now.getHours())
						const minutes = this.pad(now.getMinutes())
						const seconds = this.pad(now.getSeconds())
						const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
						this.date.selectedRange = {
							from: null,
							to: formattedDate,
						}
					} else {
						this.date.selectedRange = {
							from: null,
							to: null,
						}
					}
					this.cachedDate = _.cloneDeep(this.date)
					this.applySelection()
					break
				}
				default: {
					this.cachedChips = _.cloneDeep(this.selectedChips)
					this.cachedFilters = _.cloneDeep(this.filters)
					this.cachedDate = _.cloneDeep(this.date)
				}
			}
			if (
				name !== 'clear' &&
				!this.filterValues.some((filter) => filter.name === name) &&
				!Object.keys(this.filters).some((filter) => filter === name)
			) {
				this.filterModalIsVisible = true
			}
		},
		isButtonActive(name) {
			if (this.filterModalIsVisible && this.currentModalFilter === name) return true

			switch (name) {
				case 'clear': {
					return this.currentModalFilter === 'clear' || this.enableClearButton
				}
				case 'recent':
				case 'my_questions':
				case 'bookmark':
				case 'scheduled':
				case 'admin':
				case 'users':
				case 'register':
				case 'schedule':
				case 'categories':
				case 'follow':
				case 'event_follow':
				case 'registered': {
					const filterValue = this.filterValues.find(
						(filter) => filter.name === name
					).filter
					return (
						this.selectedChips.filters &&
						this.selectedChips.filters.some((filter) => filter === filterValue)
					)
				}
				case 'myposts': {
					return this.filters[name]
				}
				case 'sort': {
					return this.filters.field
				}
				case 'date': {
					return (
						(this.date.selectedRange.to || this.date.selectedRange.from) &&
						!this.filters.past
					)
				}
				case 'past': {
					return this.filters.past
				}
				default:
					return (
						(this.currentModalFilter === name && this.filterModalIsVisible) ||
						(this.selectedChips[name] && this.selectedChips[name].length)
					)
			}
		},
		excludeConflictFilters(currentFilter) {
			return this.mutuallyExclusiveFilters[currentFilter] || []
		},
		scrollPageTop() {
			this.$nextTick(() => {
				window.scrollTo({ top: 0, behavior: 'smooth' })
			})
		},
		resetFilters({ clearSearch = false } = {}) {
			this.filterModalIsVisible = false
			this.currentModalFilter = 'clear'
			this.currentModalLabel = null
			this.selectedChips = {}
			this.filters = {
				page: 1,
				myposts: false,
				past: false,
				field: null,
			}
			this.date = {
				selectedRange: {
					from: null,
					to: null,
				},
				option: null,
				error: '',
			}
			this.cachedChips = null

			if (clearSearch) {
				this.restoreSearch('')
			}
		},
		clearFilter(name) {
			this.filters.page = 1
			switch (name) {
				case 'chapters':
				case 'tags': {
					this.selectedChips[name] = []
					break
				}
				case 'recent':
				case 'my_questions':
				case 'bookmark':
				case 'scheduled':
				case 'admin':
				case 'users':
				case 'register':
				case 'schedule':
				case 'categories':
				case 'follow':
				case 'event_follow':
				case 'registered': {
					const filterItem = this.filterValues.find((value) => value.name === name)
					this.selectedChips.filters = this.selectedChips.filters.filter(
						(filter) => filter !== filterItem.filter
					)
					break
				}
				case 'sort': {
					this.filters.field = null
					break
				}
				case 'date': {
					this.date = {
						selectedRange: {
							from: null,
							to: null,
						},
						option: null,
						error: '',
					}
					this.$nextTick(() => {
						if (this.$refs.agendaDateStrip) {
							this.$refs.agendaDateStrip.scrollToActive()
						}
					})
					break
				}
				case 'past': {
					this.date.selectedRange.to = null
					this.filters.past = false
					break
				}
				case 'myposts': {
					this.filters.myposts = false
					break
				}
				default: {
					this.selectedChips[name] = []
				}
			}
			this.scrollPageTop()
			this.getFilteredItems()
		},
		closeModal() {
			this.filterModalIsVisible = false

			this.selectedChips = _.cloneDeep(this.cachedChips)
			this.filters = _.cloneDeep(this.cachedFilters)
			this.date = _.cloneDeep(this.cachedDate)
			this.cachedChips = null
			this.cachedFilters = null
			this.cachedDate = null

			if (this.enableClearButton) {
				this.currentModalFilter = 'clear'
			}
		},

		applySelection() {
			this.scrollPageTop()
			this.filters.page = 1
			switch (this.currentModalFilter) {
				case 'sort': {
					if (this.filters.field !== this.cachedFilters.field) {
						if (this.filterModalIsVisible) {
							this.toggleFilterModalIsVisible()
						}
						this.getFilteredItems()
					}
					break
				}
				case 'date': {
					if (!this.cachedDate || !_.isEqual(this.date.selectedRange, this.cachedDate)) {
						if (this.filterModalIsVisible) {
							this.toggleFilterModalIsVisible()
						}
						this.filters.past = false
						this.getFilteredItems()
					}
					break
				}
				default: {
					if (this.enableClearButton) {
						this.currentModalFilter = 'clear'
					} else {
						if (
							!_.isEqual(this.selectedChips, this.cachedChips) ||
							!_.isEqual(this.filters, this.cachedFilters) ||
							!_.isEqual(this.date, this.cachedDate)
						) {
							this.getFilteredItems()
						}
					}
					if (this.filterModalIsVisible) {
						this.toggleFilterModalIsVisible()
					}
				}
			}
		},
		setItem(payload) {
			const { filter, item } = payload

			switch (filter) {
				case 'sort': {
					this.filters.field = item
					break
				}
				case 'date': {
					if (!this.isDateFilterValid(this.date.selectedRange, item)) {
						this.date.error =
							'The end date of the filter must be greater than the start date'
						this.date.option = null
						break
					} else {
						const { date, option } = item
						this.date.selectedRange = {
							from:
								option === 'clear'
									? date.from
									: date.from ?? this.date.selectedRange.from,
							to:
								option === 'clear'
									? date.to
									: date.to ?? this.date.selectedRange.to,
						}
						this.date.option = option ?? null
						break
					}
				}
				default: {
					if (!this.selectedChips[filter]) {
						this.$set(this.selectedChips, filter, [item])
					} else if (this.selectedChips[filter].some((chip) => chip === item)) {
						this.selectedChips[filter] = this.selectedChips[filter].filter(
							(chip) => chip !== item
						)
					} else {
						this.selectedChips[filter] = [...this.selectedChips[filter], item]
					}
				}
			}
		},
		isDateFilterValid(currentDateRange, dateValue) {
			const { date, time, type } = dateValue
			const { from, to } = currentDateRange || {}

			const isThisEndDateForFullRange = from && type === 'to'
			const isThisStartDateForFullRange = to && type === 'from'

			if (isThisEndDateForFullRange) {
				const fromTimestamp = Math.floor(new Date(currentDateRange.from).getTime() / 1000)
				const toTimestamp = Math.floor(new Date(`${date} ${time}`).getTime() / 1000)

				return toTimestamp > fromTimestamp
			}

			if (isThisStartDateForFullRange) {
				const fromTimestamp = Math.floor(new Date(`${date} ${time}`).getTime() / 1000)
				const toTimestamp = Math.floor(new Date(currentDateRange.to).getTime() / 1000)

				return fromTimestamp < toTimestamp
			}

			return true
		},
		pad(number) {
			return (number < 10 ? '0' : '') + number
		},
		cacheCurrentFilters(value) {
			let routeName = null
			switch (this.$route.name) {
				case 'event-agenda':
				case 'directory':
				case 'threads':
					routeName = `${this.$route.name}_${value}`
					break
				default:
					routeName = this.$route.name
			}
			this.cachePageFilters({
				name: routeName,
				filters: {
					currentModalFilter: this.currentModalFilter,
					selectedChips: this.selectedChips,
					filters: this.filters,
					date: this.date,
					search: this.search,
				},
			})
		},
		setCachedFilters(value) {
			let routeName = null
			switch (this.$route.name) {
				case 'directory':
				case 'threads':
				case 'event-agenda':
					routeName = `${this.$route.name}_${value}`
					break
				default:
					routeName = this.$route.name
			}

			const cached = this.cachedPageFilters[routeName]
			if (cached) {
				const { currentModalFilter, date, filters, selectedChips, search } = cached

				this.isRestoringCachedFilters = true

				this.currentModalFilter = currentModalFilter
				this.date = date
				this.filters = filters
				this.selectedChips = selectedChips

				if (shouldCacheSearchForRoute(this.$route.name)) {
					this.setSearch(search || '')
				} else {
					this.setSearch('')
				}

				this.$nextTick(() => {
					this.isRestoringCachedFilters = false
				})
			} else {
				this.setSearch('')
			}
		},
		getFilteredItems() {
			switch (this.$route.name) {
				case 'bookmark-list': {
					this.getProfileBookmarkList({
						source: this.source,
						query: this.requestQuery,
					})
					break
				}
				case 'giveaway-list': {
					this.getGiveaways(this.requestQuery)
					break
				}
				case 'exhibitor-files-by-id': {
					this.getPartnerFiles(this.requestQuery)
					break
				}
				case 'event-session-questions': {
					this.getSessionQuestions(this.requestQuery)
					break
				}
				case 'event-session-speakers': {
					this.getAllSessionsSpeaker(this.requestQuery)
					break
				}
				case 'sub-session-list': {
					this.getSubSessions(this.requestQuery)
					break
				}
				case 'event-links-by-id': {
					this.getActionLinks(this.requestQuery)
					break
				}
				case 'sub-directory-by-id': {
					this.getSubDirectories(this.requestQuery)
					break
				}
				case 'event-actions-by-id': {
					this.getActionFiles(this.requestQuery)
					break
				}
				case 'polls-users': {
					this.getPollUsers(this.requestQuery)
					break
				}
				case 'event-speakers': {
					this.getEventSpeakersById(this.requestQuery)
					break
				}
				case 'exhibitor-staff': {
					this.getBoothStaff(this.requestQuery)
					break
				}
				case 'partners': {
					this.fetchPartners(this.requestQuery)
					break
				}
				case 'threads': {
					this.fetchPosts(this.requestQuery)
					break
				}
				case 'events': {
					this.fetchEvents(this.requestQuery)
					break
				}
				case 'forums': {
					this.fetchForumCategories(this.requestQuery)
					break
				}
				case 'attendees':
				case 'users': {
					this.getAttendeesEvent(this.requestQuery)
					break
				}
				case 'directory': {
					this.getDirectories(this.requestQuery)
					break
				}
				case 'resources': {
					this.getResources(this.requestQuery)
					break
				}
				case 'event-agenda': {
					this.getAgendaEvent(this.requestQuery)
					break
				}
				case 'forums-by-category-id': {
					this.fetchForums(this.requestQuery)
					break
				}
			}
		},
		onPageChange(page) {
			if (this.filterModalIsVisible) {
				this.filterModalIsVisible = false
				this.closeModal()
				return
			}
			this.filters.page = page
			window.scrollTo(0, 0)

			this.getFilteredItems()
		},
		async sortingLists() {
			let name = this.$route.name
			switch (name) {
				case 'attendees': {
					await this.getSort({ name: 'users', sources: 'attendeesList' })
					break
				}
				case 'users': {
					await this.getSort({ name: 'users', sources: 'nearMeList' })
					break
				}
				case 'partners': {
					await this.getSort({ name: 'partners', sources: 'exhibitorsList' })
					break
				}
				case 'event-session-speakers': {
					await this.getSort({ name: 'speakers', sources: 'speakers-session' })
					break
				}
				case 'event-speakers': {
					await this.getSort({ name: 'speakers', sources: 'speakers-event' })
					break
				}
				case 'exhibitor-staff': {
					await this.getSort({ name: 'users', sources: 'boothStaffList' })
					break
				}
				case 'threads': {
					await this.getSort({ name: 'threads', sources: 'newsList' })
					break
				}
				case 'forums-by-category-id': {
					await this.getSort({ name: 'forums', sources: 'forumsList' })
					break
				}
				case 'events': {
					await this.getSort({ name: 'events', sources: 'eventsList' })
					break
				}
				case 'event-checkin': {
					await this.getSort({ name: 'event-checkin', sources: 'checkInLogList' })
					break
				}
				case 'my-agenda-events': {
					await this.getSort({ name: 'event-agenda', sources: 'agendaDaysList' })
					break
				}
				case 'event-agenda': {
					await this.getSort({ name: 'event-agenda', sources: 'agendaList' })
					break
				}
				case 'resource':
				case 'resources': {
					await this.getSort({ name: 'resources', sources: 'resourcesList' })
					break
				}
				default: {
					break
				}
			}
		},
		restoreSearch(search = '') {
			this.isRestoringCachedFilters = true
			this.setSearch(search || '')

			this.$nextTick(() => {
				this.isRestoringCachedFilters = false
			})
		},
	},
	computed: {
		...mapGetters('settings', ['appCore', 'user', 'eventSettings']),
		...mapGetters('event', ['eventTracks', 'attendees']),
		...mapGetters('auth', ['profile']),
		...mapGetters('tag', ['tags', 'isTagsLoading', 'tagsMeta']),
		...mapGetters('list', ['listsMeta']),
		...mapGetters('app', ['cachedPageFilters', 'search', 'sortLists', 'sortLoading']),
		categoryId() {
			if (this.$route.query.category_id && this.$route.name === 'resources') {
				return this.$route.query.category_id
			}
			return false
		},
		defaultSort() {
			if (!Array.isArray(this.sortLists)) return ''
			const field = this.sortLists.find((item) => item.default === 1)
			return field ? field.field : ''
		},
		chipsList() {
			const routeName = this.$route.name
			const routeQuery =
				this.$route.name === 'resources'
					? { advance: this.$route.query.advance }
					: this.$route.query

			if (!this.appCore) {
				return []
			}
			if (this.chipsFromAppCore.some((chip) => chip === routeName)) {
				const menuItem =
					this.appCore.appMenuNormalized.baseMenuItems.find((item) => {
						if (item.route.name !== routeName) return false

						const { query: configQuery } = item.route
						if (routeName === 'directory') {
							const urlCategoryId = String(this.$route.query.category_id || '')
							const configCategoryId = String(configQuery.category_id || '')
							return urlCategoryId === configCategoryId
						}

						if (routeName === 'threads') {
							const urlThreadMenuId = String(this.$route.query.thread_menu_id || '')
							const configThreadMenuId = String(configQuery.thread_menu_id || '')
							return urlThreadMenuId === configThreadMenuId
						}
						const queryCurrentParams = _.mapValues(routeQuery, (value) => String(value))
						const planeQueryCurrentObjectParams = _.mapValues(configQuery, (value) =>
							String(value)
						)
						return _.isEqual(queryCurrentParams, planeQueryCurrentObjectParams)
					}) || {}

				const { chips = [] } = menuItem
				if (['threads', 'resources'].includes(this.$route.name)) {
					if (!chips) {
						return [{ name: 'sort' }]
					}
					return [...chips, { name: 'sort' }]
				}
				return chips
			} else {
				switch (routeName) {
					case 'events': {
						return this.eventSettings
							? [
									...this.eventSettings.normalizedChips,
									{ name: 'sort', content: 'Sort by' },
							  ]
							: [{ name: 'sort', content: 'Sort by' }]
					}
					case 'sub-session-list': {
						const filter_name = this.eventSettings?.subsession_filter_name

						const filter = this.eventSettings?.subsession_filter

						if (!filter_name || !filter) {
							return []
						}
						const filterNames = filter_name.split(',')
						const filterContent = filter.split(',')

						const chips = filterNames.map((name, index) => {
							return { name: name, content: filterContent[index] }
						})
						return chips
					}
					case 'event-agenda': {
						const filter_name = this.eventSettings?.agenda_filter_name

						const filter = this.eventSettings?.agenda_filter

						if (!filter_name || !filter) {
							return []
						}
						const filterNames = filter_name.split(',')
						const filterContent = filter.split(',')

						const chips = filterNames.map((name, index) => {
							return { name: name, content: filterContent[index] }
						})
						return chips
					}
					case 'users': {
						return !this.user || !Array.isArray(this.user.normalizedChips)
							? [{ name: 'sort', content: 'Sort by' }]
							: [...this.user.normalizedChips, { name: 'sort', content: 'Sort by' }]
					}
					case 'attendees': {
						if (
							!this.eventSettings ||
							!this.eventSettings.attendee_filter ||
							!this.eventSettings.attendee_filter_name
						) {
							return [{ name: 'sort', content: 'Sort by' }]
						}
						const filterNames = this.eventSettings.attendee_filter.split(',')
						const filterContent = this.eventSettings.attendee_filter_name.split(',')

						const chips = filterNames.map((name, index) => {
							return { name: name, content: filterContent[index] }
						})
						return [...chips, { name: 'sort', content: 'Sort by' }]
					}
					case 'exhibitor-staff': {
						return [{ name: 'sort', content: 'Sort by' }]
					}
					case 'partners': {
						if (
							!this.eventSettings ||
							!this.eventSettings.exhibitors_filter ||
							!this.eventSettings.exhibitors_filter_name
						) {
							return [{ name: 'sort', content: 'Sort by' }]
						}
						const filterNames = this.eventSettings.exhibitors_filter.split(',')
						const filterContent = this.eventSettings.exhibitors_filter_name.split(',')
						const chips = filterNames.map((name, index) => {
							return { name: name, content: filterContent[index] }
						})
						return [...chips, { name: 'sort', content: 'Sort by' }]
					}
					case 'event-session-speakers':
					case 'event-speakers': {
						return [
							{
								name: 'clear',
								content: 'All',
							},
							{ name: 'sort', content: 'Sort by' },
							{
								name: 'bookmark',
								content: 'Bookmarked',
							},
						]
					}
					case 'forums-by-category-id': {
						return [
							{
								name: 'clear',
								content: 'All',
							},
							{
								name: 'bookmark',
								content: 'Followed',
							},
							{
								name: 'myposts',
								content: 'My Discussions',
							},
						]
					}
					case 'event-session-questions': {
						return [
							{
								name: 'clear',
								content: 'Popular',
							},
							{
								name: 'recent',
								content: 'Recent',
							},
							{
								name: 'my_questions',
								content: 'My Questions',
							},
						]
					}
					case 'forums': {
						return [
							{
								name: 'clear',
								content: 'All',
							},
							{
								name: 'bookmark',
								content: 'My Communities',
							},
							{
								name: 'chapters',
								content: 'My Groups',
							},
						]
					}
					case 'polls-users': {
						return [
							{
								name: 'clear',
								content: 'All',
							},
							{
								name: 'options',
								content: 'Options',
							},
							{
								name: 'sort',
							},
						]
					}
					default:
						return []
				}
			}
		},
		isFiltersEmpty() {
			const values = Object.values(this.selectedChips)
			return !values.some((array) => array.length)
		},
		enableClearButton() {
			return (
				this.isFiltersEmpty &&
				!this.filterModalIsVisible &&
				!this.filters.field &&
				!this.date.selectedRange.to &&
				!this.date.selectedRange.from &&
				!this.filters.past &&
				!this.filters.myposts
			)
		},
		userId() {
			return this.profile && this.profile.user_id
		},
		initQuery() {
			const pageQuery = `?page=${this.filters.page}`
			switch (this.$route.name) {
				case 'bookmark-list': {
					const forumQuery = this.isDiscussions ? '&thread_type=2' : ''
					return (
						pageQuery +
						`&filter=bookmark&source=${this.source}-bookmarks&expand=${this.source}List&sort=-bookmark${forumQuery}`
					)
				}
				case 'giveaway-list': {
					return pageQuery + `&id=${this.$route.query.id}`
				}
				case 'exhibitor-files-by-id': {
					return pageQuery + `&partner_id=${this.$route.query.partner_id}`
				}
				case 'event-session-questions': {
					return pageQuery + `&qna_id=${this.$route.query.qna_id}`
				}
				case 'event-session-speakers': {
					if (this.isButtonActive('sort')) {
						return pageQuery + `&events_agenda_id=${this.$route.params.id}`
					} else {
						return (
							pageQuery +
							`&events_agenda_id=${this.$route.params.id}&sort=${this.defaultSort}`
						)
					}
				}
				case 'sub-directory-by-id': {
					return (
						pageQuery +
						`&category_id=${this.$route.query.category_id}&directory_parent_id=${this.$route.params.id}&expand=public`
					)
				}
				case 'event-links-by-id': {
					return pageQuery + `&action_id=${this.$route.params.actionId}`
				}
				case 'event-actions-by-id': {
					return pageQuery + `&action_id=${this.$route.params.actionId}`
				}
				case 'users': {
					if (this.isButtonActive('sort')) {
						return pageQuery
					}
					return pageQuery + `&sort=user_lname`
				}
				case 'polls-users': {
					return pageQuery + `&id=${this.$route.query.thread_id}&expand=poll_answer`
				}

				case 'forums-by-category-id': {
					return pageQuery + `&thread_type=2&thread_category_id=${this.$route.params.id}`
				}
				case 'event-speakers': {
					if (this.isButtonActive('sort')) {
						return pageQuery + `&event_id=${+this.$route.params.id}`
					} else {
						return (
							pageQuery +
							`&event_id=${+this.$route.params.id}&sort=${this.defaultSort}`
						)
					}
				}
				case 'partners': {
					return pageQuery + `&group_id=${this.$route.params.id}`
				}
				case 'exhibitor-staff': {
					if (this.isButtonActive('sort')) {
						return `page=${this.filters.page}&partner_id=${this.$route.params.id}`
					} else {
						return `page=${this.filters.page}&partner_id=${this.$route.params.id}&sort=user_lname`
					}
				}
				case 'attendees': {
					const eventIdParam = `&event_id=${this.$route.params.id}`
					if (this.isButtonActive('event_follow') && this.isButtonActive('sort')) {
						return pageQuery + eventIdParam
					}
					if (this.isButtonActive('event_follow')) {
						return pageQuery + eventIdParam + '&sort=user_lname'
					}
					if (this.isButtonActive('sort')) {
						return pageQuery + eventIdParam + '&filter=event'
					}
					return pageQuery + eventIdParam + '&filter=event&sort=user_lname'
				}
				case 'threads': {
					if (this.isButtonActive('sort')) {
						return pageQuery + `&thread_menu_id=${this.$route.query.thread_menu_id}`
					} else {
						return (
							pageQuery +
							`&thread_menu_id=${this.$route.query.thread_menu_id}&sort=-thread_time_order`
						)
					}
				}
				case 'events': {
					if (this.isButtonActive('sort')) {
						return pageQuery
					} else {
						return pageQuery + `&sort=event_order`
					}
				}
				case 'forums': {
					return pageQuery + `&category_type=1`
				}
				case 'directory': {
					return pageQuery + `&category_id=${this.$route.query.category_id}&expand=public`
				}
				case 'resources': {
					const pathView = this.search ? '&expand=path' : ''
					const categoryParam = this.categoryId ? `&parentId=${this.categoryId}` : ''
					const sortParam = this.isButtonActive('sort') ? '' : '&sort=resources_name'
					return pageQuery + categoryParam + sortParam + pathView
				}
				case 'sub-session-list': {
					const eventIdParam = `&event_id=${this.$route.query.event_id}`
					return (
						pageQuery +
						`&parent_agenda_id=${this.$route.query.events_agenda_id}${eventIdParam}`
					)
				}
				case 'event-agenda': {
					if (
						this.isButtonActive('past') ||
						this.isButtonActive('date') ||
						this.isSearch
					) {
						return pageQuery + `&event_id=${this.$route.params.id}`
					} else {
						return (
							pageQuery +
							`&event_id=${this.$route.params.id}` +
							this.buildAgendaTimeQuery()
						)
					}
				}
				default: {
					return pageQuery
				}
			}
		},
		requestQuery() {
			const keys = Object.keys(this.selectedChips)
			const values = Object.values(this.selectedChips)

			const initQuery = this.initQuery
			let query = initQuery

			keys.forEach((key, keyIndex) => {
				switch (key) {
					case 'speakers': {
						values[keyIndex].forEach((value) => {
							query += `&speaker_ids[]=${value}`
						})
						break
					}
					case 'options': {
						values[keyIndex].forEach((value) => {
							query += `&poll_answer_ids[]=${value}`
						})
						break
					}
					case 'author': {
						values[keyIndex].forEach((value) => {
							query += `&resource_author[]=${value}`
						})
						break
					}
					case 'chapters': {
						values[keyIndex].forEach((value) => {
							query += `&chapter_id[]=${value}`
						})
						break
					}
					case 'tags': {
						values[keyIndex].forEach((value) => {
							query += `&tag_ids[]=${value}`
						})
						break
					}
					case 'filters': {
						values[keyIndex].forEach((value) => {
							query += `&filter=${value}`
						})
						break
					}
					case 'tracks': {
						values[keyIndex].forEach((value) => {
							query += `&tracks_id[]=${value}`
						})
						break
					}
					case 'category': {
						values[keyIndex].forEach((value) => {
							query += `&category_id[]=${value}`
						})
						break
					}
					case 'type': {
						values[keyIndex].forEach((value) => {
							query += `&resource_type[]=${value}`
						})
						break
					}
					default: {
						values[keyIndex].forEach((value) => {
							query += `&${key}[]=${encodeURIComponent(value)}`
						})
					}
				}
			})

			Object.keys(this.filters).forEach((key) => {
				switch (key) {
					case 'myposts': {
						if (this.filters.myposts) {
							query += `&user_id=${this.userId}`
						}
					}
				}
			})
			if (this.filters.field) {
				query += `&sort=${this.filters.field}`
			}

			if (this.date.selectedRange.to) {
				query += `&to_timestamp=${
					Math.floor(new Date(this.date.selectedRange.to).getTime()) / 1000
				}`
			}

			if (this.date.selectedRange.from) {
				query += `&from_timestamp=${
					Math.floor(new Date(this.date.selectedRange.from).getTime()) / 1000
				}`
			}

			if (this.search) {
				query += `&search=${this.search}`
			}

			return query
		},
		cachedFiltersKey() {
			let key = null
			switch (this.$route.name) {
				case 'threads':
					key = this.$route.query.thread_menu_id
					break
				case 'directory':
					key = this.$route.query.category_id
					break
				case 'attendees':
				case 'event-agenda':
					key = this.$route.params.id
					break
			}
			return key
		},
	},
	watch: {
		isSearch(newVal) {
			if (newVal) {
				this.getFilteredItems()
			} else {
				this.getFilteredItems()
			}
		},
		search() {
			if (this.isRestoringCachedFilters) return
			clearTimeout(this.timer)

			this.filters.page = 1
			this.timer = setTimeout(() => {
				this.getFilteredItems()
			}, DEBOUNCE_TIMEOUT)
		},
		'$route.query.thread_menu_id': {
			handler(newValue, oldValue) {
				if (this.$route.name !== 'threads') return

				if (oldValue) {
					this.cacheCurrentFilters(+oldValue)
				}

				this.resetFilters()
				this.setCachedFilters(+newValue)
			},
		},

		'$route.query.category_id': {
			handler(newValue, oldValue) {
				if (this.$route.name === 'threads') return

				if (oldValue) {
					this.cacheCurrentFilters(oldValue)
				}

				this.resetFilters()
				this.setCachedFilters(newValue)
			},
		},
	},
	created() {
		if (!this.listsMeta.length) {
			this.getListsMeta()
		}

		this.setCachedFilters(this.cachedFiltersKey)
	},
	beforeRouteLeave(to, from, next) {
		this.cacheCurrentFilters(this.cachedFiltersKey)
		this.resetFilters()
		next()
	},
	data() {
		return {
			filterModalIsVisible: false,
			currentModalFilter: 'clear',
			currentModalLabel: null,
			selectedChips: {},
			filters: {
				page: 1,
				myposts: false,
				past: false,
				field: null,
			},
			date: {
				selectedRange: {
					from: null,
					to: null,
				},
				option: null,
				error: '',
			},
			cachedChips: null,
			cachedDate: null,
			cachedFilters: null,
			timer: 0,
			chipsFromAppCore: ['threads', 'directory', 'resources'],
			isRestoringCachedFilters: false,
			filterValues: [
				{ name: 'admin', filter: 'admin-news' },
				{ name: 'bookmark', filter: 'bookmark' },
				{ name: 'recent', filter: 'recent' },
				{ name: 'my_questions', filter: 'my_questions' },
				{ name: 'users', filter: 'user-news' },
				{ name: 'register', filter: 'follow' },
				{ name: 'schedule', filter: 'schedule' },
				{ name: 'categories', filter: 'follow' },
				{ name: 'follow', filter: 'follow' },
				{ name: 'registered', filter: 'registered' },
				{ name: 'scheduled', filter: 'scheduled' },
				{ name: 'event_follow', filter: 'event_follow' },
			],
			mutuallyExclusiveFilters: {
				scheduled: ['registered'],
				registered: ['scheduled'],
				follow: ['schedule', 'schedregist'],
				schedule: ['follow', 'schedregist'],
				schedregist: ['follow', 'schedule'],
				recent: ['my_questions'],
				my_questions: ['recent'],
			},
		}
	},
}
